import config from '../../config';
import { checkStatus, handleRequestError } from '../utils/helpers';
import { HIDE_PASSCODE, PASSCODE_PASSED, SHOW_PASSCODE } from './constants';

export const showPasscode = idOrRoute => ({ type: SHOW_PASSCODE, payload: idOrRoute });
export const hidePasscode = () => ({ type: HIDE_PASSCODE });

export const setPasscodePassed = barber => ({
  type: PASSCODE_PASSED,
  payload: barber,
});

export const validatePasscode = (barberId, passcode) => {
  const url = `${config.url}/barber/validate/${barberId}`;

  return dispatch => fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ passcode }),
  })
    .then(checkStatus)
    .then(response => response.passcode)
    .catch(handleRequestError(dispatch));
};



// WEBPACK FOOTER //
// ./src/app/passcode/actions.js